<template>
  <div class="master-container">
    <div v-if="loadingGlobal" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <moow-empty-state
      v-else-if="chatError"
      icon="announcement"
      :title="i18n_local.chat_unavailable"
      :description="chatError"
      ctaButtonText="Go to dashboard"
      @emitCtaClick="goToDashboard()"
    />
    <div v-else class="side-container master-container">
      <b-row xl="12" lg="12" md="12" sm="12" style="height: 100%">
        <!-- room-list -->
        <b-col
          lg="3"
          :cols="roomsColSize"
          class="room-list-container moow-vert-scrollbar white-background"
          v-if="showRoomsCol && chatEnabled"
        >
        <b-row class="rooms-header">
          <b-col><p>Inbox</p></b-col>
        </b-row>
          <!-- <el-tabs v-model="activeBox">
            <el-tab-pane label="Inbox" name="inbox" class="inbox-tab-pane"> -->
              <b-row v-if="allUserRoomsOrdered.length == 0">
                <b-col>
                  <md-card>
                    <div
                      v-if="loadingUser"
                      class="loader-rolling-local"
                      style="margin: 0 auto"
                    ></div>
                    <div
                      v-else-if="!chatReady"
                      class="loader-rolling-local"
                      style="margin: 0 auto"
                    ></div>
                    <md-card-content v-else>
                      <p class="moow-info-txt">
                        Your chats will be displayed here
                      </p>
                      <p class="moow-info-txt">
                        Tenants can start chatting with landlords from the
                        Marketplace
                      </p>
                    </md-card-content>
                  </md-card>
                </b-col>
              </b-row>
              <b-row
                v-for="(room, index) in allUserRoomsOrdered"
                :key="room.id + index"
                class="room-list-item-container"
                style="border: 1px solid #ededed; border-top: none"
              >
                <b-col
                  :disabled="isRoomCurrent(room)"
                  lg="12"
                  md="12"
                  sm="12"
                  :class="{ highlight: room.id == selectedRoomId }"
                  class="room-list-item"
                  :id="room.id"
                  v-on:click="selectRoomAsCurrentGate($event, room)"
                >
                <moow-avatar
                  :imgSource="room.avatarURL"
                  :badge="room.unseenMsg"
                  :flat="true"
                  size="large"
                ></moow-avatar>
                  <div
                    class="room-text-container"
                    :class="{ unseenMsg: room.unseenMsg }"
                  >
                    <span class="room-disp-name-holder">{{
                      room.displayName
                    }}</span>
                    <!-- <div
                      v-if="room.lastMessage"
                      class="room-xtra-info room-lts-msg-holder"
                    >latest message here</div>-->
                    <div
                      v-if="showRoomName(room)"
                      class="room-xtra-info room-name-holder"
                      :class="{ unseenMsg: room.unseenMsg }"
                    >
                      {{ room.name }}
                    </div>
                  </div>
                  <div
                    v-if="room.lastMessage"
                    class="room-time-holder"
                    :class="{ unseenMsg: room.unseenMsg }"
                  >
                    {{ formatIsoDateToDynamic(room.lastMessage.timestamp) }}
                  </div>
                  <!-- TODO: {{room.otherMember.isOnline}} -->
                </b-col>
              </b-row>
            <!-- </el-tab-pane>
          </el-tabs> -->
        </b-col>
        <!-- MESSAGE COLUMN -->
        <b-col v-if="!chatEnabled">
          <b-row align-h="center" class="mt-5" @click="enableChat">
            <!-- <moow-button
                  :type="['light']" btnText="Enable Chat" @mClick="enableChat"/> -->
            <anim-button :type="['light']" btnText="Click to start" />
          </b-row>
        </b-col>
        <b-col
          v-else-if="allUserRoomsOrdered.length > 0"
          lg="6"
          :cols="messagesColumnSize"
          class="messages-container-master white-background"
        >
          <b-row
            id="room-header-expandable"
            class="current-room-header"
            lg="12"
          >
            <b-col>
              <div id="curr-room-title" @click="toggleMemberDetailsExpansion()">
                {{ currentRoomDisplayName }} <md-icon>keyboard_arrow_down</md-icon>
              </div>
              <div
                v-if="showMemberDetails"
                class="member-details-container moow-info-txt secondary"
              >
                <div
                  v-if="loadingOtherMemberDetails"
                  class="loader-rolling-local_blue"
                  style="margin: 0 auto"
                ></div>
                <p
                  v-else-if="otherMemberDetails.placeholder"
                  class="moow-info-txt secondary"
                >
                  {{ otherMemberDetails.placeholder }}
                </p>
                <span v-if="otherMemberDetails.contactEmail"
                  ><a
                    :href="'mailto:' + otherMemberDetails.contactEmail"
                    target="_blank"
                    >{{ otherMemberDetails.contactEmail }}</a
                  ></span
                >
                <span v-else>No email</span>

                <span v-if="otherMemberDetails.contactPhone"
                  >, {{ otherMemberDetails.contactPhone }}</span
                >
                <span v-else>, No phone</span>

                <span>, </span>
                <span @click="navigateToUserProfile()" class="text-button">View Profile
                </span>
              </div>
            </b-col>
          </b-row>
          <b-row
            class="msg-container messages-container-content moow-vert-scrollbar"
            id="msg-log"
            v-chat-scroll="{ always: false, smooth: true }"
          >
            <b-col>
              <b-row v-if="loadingRoomMessages" class="loader-riple"></b-row>
              <b-row v-else-if="userHasRooms">
                <b-col>
                  <div
                    v-if="loadingOlderMsgs"
                    class="loader-rolling-local load-older-btn"
                  ></div>
                  <div
                    v-else-if="!disableLoadOlderMsgs"
                    style="text-align: center; margin-bottom: 1em"
                  >
                    <b-button
                      v-if="selectedRoom"
                      @click="fetchOlderMessages"
                      variant="outline"
                      class="load-older-btn"
                      >Load Older</b-button
                    >
                  </div>
                  <div
                    lg="12"
                    md="12"
                    sm="12"
                    v-for="(message, index) in currentRoomMessages_ordered"
                    :key="index"
                    :class="setRoomMessageClass(message)"
                    style="border: 1px solid #ededed; border-top: none"
                  >
                    <div v-if="!message.hidden">
                      <i :class="getMessageStatusIconClass(message)"></i>
                      <span
                        v-if="message.msgType == 'media'"
                        class="actual-message"
                      >
                        <!-- is attachment -->
                      </span>

                      <span
                        v-else
                        class="actual-message text"
                        v-html="convertToHtml(message.textMessage, message.isOther)"
                      ></span>
                      <md-tooltip md-direction="right">{{
                        formatIsoDateToDynamic(message.timestamp)
                      }}</md-tooltip>

                      <!-- TODO: enable this but solve for the UI -->
                      <!-- <p class="message-time" v-if="message.createdAt">{{getDisplayTime(message.createdAt)}}</p> -->
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row v-else-if="noRoomMessages">
                <div class="subtle-hints">No messages</div>
              </b-row>
              <b-row v-else>
                <div>No chats</div>
              </b-row>
            </b-col>
          </b-row>
          <!-- msg input -->
          <b-row class="msg-sender-container messages-container-footer">
            <b-col lg="10" md="10" sm="9" cols="9">
                <moow-input
                  id="msg-input-txt-area"
                  v-model="txtInMsgInputField"
                  placeholder="Enter a message"
                ></moow-input>
            </b-col>
            <b-col lg="2" md="2" sm="3" cols="3">
              <moow-button :type="['light', 'fab']" @mClick="handleSendMessageButton" icon="send"/>
            </b-col>
          </b-row>
        </b-col>
        <!-- NO ROOMS PLACEHOLDER -->
        <b-col
          v-else
          class="selected-room-container"
          xl="6"
          lg="6"
          md="9"
          sm="9"
          cols="9"
        >
          <div class="inbox-empty-container">
            <img :src="inboxEmptyIcon" style="height: 100%" />
          </div>
        </b-col>
        <!-- Booking Requests Column -->
        <b-col
          lg="3"
          :cols="requestsColumnSize"
          class="listing-requests-container moow-vert-scrollbar"
          v-if="showRequestPanel && chatEnabled"
        >
          <div :key="selectedRoomId" v-if="selectedRoomId">
            <listing-requests
              ref="listingRequestsRef"
              :prospectAndOwnerUid="roomProspectAndOwnerUid"
              :status="roomRequestStatus"
              :displayForProspect="displayRequestForProspect"
              :saveRequest="saveRequestEdits"
              :loadingRedirectToggle="changeLoadingGlobal"
              @emitRedirectTo="redirectTo"
              @emitStartBookingApplication="startBookingApplication"
            ></listing-requests>
          </div>
        </b-col>
      </b-row>

      <md-button
        class="md-fab md-primary hover-button top-right"
        v-if="narrowWidth && chatEnabled"
        @click="toggleRequestsCol()"
      >
        <md-icon v-if="showRequestPanel">keyboard_arrow_right</md-icon>
        <md-icon v-else>keyboard_arrow_left</md-icon>
      </md-button>

      <md-button
        v-if="narrowWidth && chatEnabled"
        class="md-fab md-mini md-plain hover-button top-left"
        @click="toggleRoomsCol()"
      >
        <md-icon v-if="showRoomsCol">keyboard_arrow_left</md-icon>
        <md-icon v-else>keyboard_arrow_right</md-icon>
      </md-button>
    </div>
  </div>
</template>
<script>
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
import systemMessageCodes from "../config/systemMessageCodes";
import { getUserUid, formatToDynamicTime } from "../functions.js";
import { updateRequest } from "../requestRepository.js";
import { mapGetters } from "vuex";
import { updateUser } from "../users/services/userService.js";
import ListingRequests from "../components/dashboard/listingRequests.vue";
import { convertChatMessageToHtml } from "@/platform/chat/utils/chatInputHelper.js";
import {
  captureMessage,
  captureException
} from "@/utils/reporting/reportingService.js";
import ChatMessage from "@/platform/chat/model/ChatMessage";
import AttachmentMessage from "@/platform/chat/model/AttachmentMessage";
import UpdateRoomCommand from "@/platform/chat/model/UpdateRoomCommand";
import FetchMessagesQuery from "@/platform/chat/model/FetchMessagesQuery";
import CreateRoomCommand from "@/platform/chat/model/CreateRoomCommand";
import ChatAutoMessenger, {
  getInquiryChangeMessage
} from "@/platform/chat/services/ChatAutoMessenger";
var lodash = require("lodash/function");
const ENTER_KEY_CODE = 13;
import { getAccountPublicDetails } from "@/platform/account/repositories/accountRepository"
import { upsertRequest } from "../requestRepository.js";

export default {
  name: "chat",
  components: {
    "listing-requests": ListingRequests
  },
  props: {
    chatWithThisUser: {
      type: String
    },
    initialChatMsg: {
      type: String
    },
    regardingPropery: {
      type: String
    },
    bookingRequest: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      showRequestPanel: true,
      narrowWidth: true,
      displayRequestForProspect: false,
      roomProspectAndOwnerUid: [],
      roomRequestStatus: "active",
      selectedRoomId: undefined,
      selectedRoom: undefined,
      txtInMsgInputField: "",
      username: "",
      password: "",
      loadingInitialRoomSelection: true,
      loadingGlobal: false,
      loadingRoomMessages: false,
      noRoomMessages: false,
      userHasRooms: true,
      // currentRoomMessages: [],
      prevOldestMsgId: -1, // this is used to check if the room has ran out of older messages
      disableLoadOlderMsgs: false,
      loadingOlderMsgs: false,
      currentRoomDisplayName: "",
      otherMemberUid: "",
      showUserProfileLink: false,
      currentRoomIsArchived: false,
      activeBox: "inbox", // this starts the view off with inbox selected (as opposed to archived)
      userRoomStatuses: {},
      roomToWaitFor: {
        active: false,
        otherUserUid: ""
      },
      lastSeenMsgDatePerRoom: {},
      lastSeenMsgDatePerRoomThisSession: {},
      selectInitialRoomCalled: false,
      showRoomsCol: false,
      showMemberDetails: false,
      loadingOtherMemberDetails: true,
      otherMemberDetails: {}
    };
  },
  mounted() {
    var self = this;
    document.addEventListener("keydown", this.handleKeyDown);
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize(); // set the inital width before any event listener is triggered.
    this.$store.commit("toggleShowUnreadMsgBadge", false);
    this.$store.commit("setListenNewMsgsGlobally", false);
    if (this.roomsAreLoaded && !this.selectInitialRoomCalled) {
      this.selectInitialRoom(this.$route.query.roomId);
    }
    this.$emit("emitCustomAction", {action:"hideSideMenu"})

    // if chat is loaded with bookingRequest prop, then auto-start the booking process
    console.log("bookingRequest:", this.bookingRequest)
    if(this.bookingRequest) this.startBookingApplication({bookingRequest: this.bookingRequest})
  },
  beforeDestroy() {
    this.$store.commit("setListenNewMsgsGlobally", true);
    window.removeEventListener("resize", this.handleWindowResize);
    document.removeEventListener("keydown", this.handleKeyDown);
  },
  computed: {
    roomsColSize() {
      if (this.showRoomsCol) return 11;
      else return 0;
    },
    messagesColumnSize() {
      if (this.showRequestPanel || this.showRoomsCol) return 1;
      else return 12;
    },
    requestsColumnSize() {
      if (this.showRequestPanel) return 11;
      else return 0;
    },
    roomDescriptors() {
      return this.$store.getters.roomDescriptors;
    },
    chatError() {
      return this.$store.getters.chatError;
    },
    chatReady() {
      return this.$store.getters.chatReady;
    },
    roomsAreLoaded() {
      // IMPORTANT:
      //  chatReady == true only after roomDescriptors are loaded.
      //  if roomDescriptors.length == 0, there are no rooms and we don't need to wait for currentUserRooms to be loaded
      if (
        this.chatReady &&
        (this.roomDescriptors.length == 0 ||
          this.roomDescriptors.length ==
            Object.keys(this.currentUserRooms).length)
      )
        return true;
      return false;
    },
    loadingUser() {
      return this.$store.getters.loadingUser;
    },
    chatEnabled() {
      return this.$store.getters.chatEnabled;
    },
    currentUserRooms() {
      return this.$store.getters.rooms;
    },
    allUserRoomsOrdered() {
      console.log('allUserRoomsOrdered | invoked');

      var rooms = [];
      for (var roomId in this.currentUserRooms) {
        rooms.push(this.currentUserRooms[roomId]);
        // if(roomId === "CH02830fe70c674051914ab57f344059ee") console.log("room:", this.currentUserRooms[roomId])
      }

      var self = this;

      rooms.sort(function(a, b) {
        try {
          if (a.lastMessage && !b.lastMessage) {
              return -1;
          }
          if (b.lastMessage && !a.lastMessage) {
              return 1;
          }
          if (!a.lastMessage && !b.lastMessage) {
              return 0;
          }

          return (
            b.lastMessage.timestamp -
            a.lastMessage.timestamp
          );
        } catch (error) {
          return 0;
        }
      });

      return rooms;
    },
    allUserRoomsArchived() {
      return this.$store.getters.archivedRooms;
    },
    inboxedRooms() {
      this.newLocalRoomWasAddedToStore();
      return this.$store.getters.rooms;
    },
    currentRoom() {
      return this.$store.getters.currentRoom;
    },
    avatarPlaceholder() {
      return require("../assets/prof-pic-placeholder@2x.png");
    },
    inboxEmptyIcon() {
      return require("../assets/404_chat.svg");
    },
    currentChatUserId() {
      return this.$store.getters.currentChatUserId;
    },
    chatMessagingService() {
      return this.$store.getters.messagingService;
    },
    currentUserFirstName() {
      if (this.$store.getters.user) return this.$store.getters.user.firstName;
      else return false;
    },
    currentRoomMessages() {
      if (this.selectedRoomId)
        return this.$store.getters.roomMessages[this.selectedRoomId];
      return [];
    },
    currentRoomMessages_ordered() {
      console.log('currentRoomMessages_ordered | invoked');
      //       const random = this.makeid(5)
      // this.$store.commit("addNewRoom", {id: random, temp: true});
      // this.$store.commit("removeRoom", random);

      function compare(a, b) {
        return new Date(a.createdAt) - new Date(b.createdAt);
      }
      return this.currentRoomMessages.sort(compare);
    }
  },
  watch: {
    currentUserRooms: function(val) {
      if (this.roomToWaitFor.active) {
        var keys = Object.keys(val);
        for (let k of keys) {
          if (val[k].otherMember.identity) {
            this.selectRoomAsCurrent(val[k]);
            this.sendInitialMessageIfNeeded();
            this.roomToWaitFor.active = false;
          }
        }
      }
    },
    roomsAreLoaded: function(val, oldVal) {
      console.log('roomsAreLoaded watcher');
      
      if (val && !this.selectInitialRoomCalled)
        this.selectInitialRoom(this.$route.query.roomId);
    },
    currentRoomMessages: function(messages) {
      this.scrollToEndOfMessages();
      if (messages && messages.length > 0) {
        var latestMsg = messages[messages.length - 1];
        if (latestMsg && latestMsg.hidden && latestMsg.isOther) {
          if (
            latestMsg.attributes.systemCode ==
              systemMessageCodes.requestUpdateCode &&
            this.$refs.listingRequestsRef
          ) {
            var requestUpdateMsg = latestMsg.textMessage;
            var requestUpdate = JSON.parse(requestUpdateMsg);
            this.$refs.listingRequestsRef.updateRequestData(requestUpdate);
          }
        }
      }
    }
  },
  methods: {
    makeid(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    toggleMemberDetailsExpansion(){
      var el = document.getElementById('room-header-expandable');
      if(el) {
        if(!this.showMemberDetails){
          el.className += el.className ? ' expanded' : 'expanded';
          this.showMemberDetails = true
        }else {
          el.classList.remove("expanded");
          this.showMemberDetails = false
        }
      }
    },
    toggleRequestsCol() {
      this.showRequestPanel = !this.showRequestPanel;
      if (this.showRequestPanel) this.showRoomsCol = false;
    },
    toggleRoomsCol() {
      this.showRoomsCol = !this.showRoomsCol;
      if (this.showRoomsCol) this.showRequestPanel = false;
    },
    selectInitialRoom(roomId) {
      console.log('selectInitialRoom');
      
      this.selectInitialRoomCalled = true;
      if (
        this.chatWithThisUser &&
        this.chatWithThisUser != this.currentChatUserId
      )
        this.selectRoomById();
      else if (roomId) this.selectRoomById(roomId);
      else if (this.allUserRoomsOrdered && this.allUserRoomsOrdered.length > 0)
        this.selectRoomById(this.allUserRoomsOrdered[0].id);
      this.loadingInitialRoomSelection = false;
    },
    goToDashboard() {
      this.navigateTo({ where: "dashboard" });
    },
    redirectTo(payload) {
      if (payload.where == "account"){
        this.$notify({
          title: "Specify your info",
          message: "Fill in account details first"
        });
        this.navigateTo({
          where: payload.where,
          params: { postSaveRedirect: "chat", openWithTab:payload.openTab, chatRoomId: this.selectedRoomId, bookingRequest: payload.bookingRequest }
        });
      }else if (payload.where == "bookingApplication" && payload.params) {
        this.navigateTo({ where: payload.where, params: payload.params });
      }
    },
    startBookingApplication(payload){
      if(!payload.bookingRequest) return;
      this.changeLoadingGlobal(true);
      upsertRequest(payload.bookingRequest).then(resp => {
          if (resp) {
            this.navigateTo({
              where: "bookingApplication",
              params: { bookingRequest: payload.bookingRequest }
            });
            this.changeLoadingGlobal(false);
          } else {
            this.changeLoadingGlobal(false);
          }
        });
    },
    convertToHtml(content, messageFromOther) {
      return convertChatMessageToHtml(content, messageFromOther);
    },
    enableChat() {
      this.$store.commit("SET_CHAT_ENABLED", true);
      updateUser(getUserUid(), { chatEnabled: true })
    },
    changeLoadingGlobal(value) {
      this.loadingGlobal = value;
    },
    formatIsoDateToDynamic(isoDateString) {
      return formatToDynamicTime(isoDateString);
    },
    getAttachmentUrl(payload) {
      return payload.url(); //function (returns promise of string)
      // TODO: check for expiration for fetch a new url
      // var currDate = new Date()
      // if(currDate > payload.urlExpiry()){
      //
      // }else{
      // }
    },
    handleWindowResize() {
      this.narrowWidth = window.innerWidth <= 990;
      if (this.narrowWidth) {
        this.showRequestPanel = false;
        this.showRoomsCol = false;
      } else {
        this.showRequestPanel = true;
        this.showRoomsCol = true;
      }
    },
    handleKeyDown(event) {
      if (event.keyCode == ENTER_KEY_CODE && !event.shiftKey) {
        // prevent default behavior
        event.preventDefault();
        this.handleSendMessageButton();
        return false;
      }
    },
    urlIsImage(url) {
      return url.match(/\.(jpeg|jpg|gif|png)$/) == null;
    },
    attachFile(fieldName, fileList) {
      try {
        for (var i = 0; i < fileList.length; i++) {
          this.sendAttachment(fileList[i], fileList[i].name);
        }
      } catch (err) {
        // TODO: implement logging
        //console.log("CHAT | attachFile | failed to send: ", err)
      }
    },
    navigateToUserProfile() {
      if (!this.showUserProfileLink) return;
      try {
        this.navigateTo({
          where: "user",
          params: { id: this.otherMemberUid }
        });
      } catch (err) {
        this.showUserProfileLink = false;
      }
    },
    selectRoomById(roomId) {
      if (roomId) {
        this.selectRoomAsCurrent(this.getLocalRoomById(roomId));
        return;
      }

      if (
        this.chatWithThisUser &&
        this.chatWithThisUser != this.currentChatUserId
      ) {
        // this.chatWithThisUser is uid of the user which is equals the identity of a chat user
        let existingRoomId = this.findRoomWithUser({
          otherUserIdentity: this.chatWithThisUser,
          currentUserIdentity: this.currentChatUserId
        });
        if (existingRoomId) {
          this.updateRoomInIfNeeded(existingRoomId, this.regardingPropery);
          this.selectRoomAsCurrent(this.getLocalRoomById(existingRoomId));
          this.sendInitialMessageIfNeeded();
        } else {
          this.createNewRoom(
            this.regardingPropery,
            this.chatWithThisUser,
            this.currentChatUserId
          );
          this.roomToWaitFor = {
            active: true,
            otherUserUid: this.chatWithThisUser
          };
        }
      }
      if (this.userHasRooms) this.setCurrentRoomToDefault();
    },
    setCurrentRoomToDefault() {
      try {
        let room;
        let lastRoomId = sessionStorage.getItem("lastSelectedRoomId");
        if (lastRoomId) room = this.getLocalRoomById(lastRoomId);
        if (!room) room = this.getFirstRoomFromInbox();
        if (room) this.selectRoomAsCurrent(room);
      } catch (err) {}
    },
    getFirstRoomFromInbox() {
      if (this.allUserRoomsOrdered) return this.allUserRoomsOrdered[0];
      throw "no rooms found";
    },
    findRoomWithUser({ otherUserIdentity, currentUserIdentity }) {
      for (var roomId of Object.keys(this.currentUserRooms)) {
        var room = this.currentUserRooms[roomId];
        if (room.users && room.users.length > 2) continue; //skip empty and group rooms
        let otherUser = this.findOtherUserInBinaryRoom(
          room,
          currentUserIdentity
        ); // don't worry in O2 complexity growth cause we limit this to only binary rooms
        if (otherUser.identity == otherUserIdentity) {
          return room.id;
        }
      }
    },
    createNewRoom(roomName, otherUserUid, currentUserUid) {
      !roomName ? (roomName = "unk") : void 0;
      this.chatMessagingService.createRoom(
        new CreateRoomCommand({
          roomName: roomName,
          isPrivateRoom: true,
          oppositeUserId: otherUserUid,
          currentUserId: currentUserUid
        })
      );
    },
    findOtherUserInBinaryRoom(room, currentUserIdentity) {
      for (let roomUser of room.users) {
        if (roomUser.identity != currentUserIdentity) return roomUser;
      }
    },
    getLocalRoomById(roomId) {
      let iRoom = this.$store.getters.rooms[roomId];
      if (iRoom) return iRoom;
      else {
        let aRoom = this.$store.getters.archivedRooms[roomId];
        if (aRoom) return aRoom;
      }

      return false;
    },
    selectRoomAsCurrent(room) {
      this.disableLoadOlderMsgs = false;
      this.selectedRoom = room;
      this.selectedRoomId = room.id;
      this.$store.dispatch("changeCurrentRoom", room);
      sessionStorage.setItem("lastSelectedRoomId", room.id);
      this.setSessionLastSeenMessages(room);
      this.mapRoomDataToModel(room);
    },
    mapRoomDataToModel(room) {
      if (!room) return;
      room.unseenMsg = false;

      this.currentRoomDisplayName = room.displayName;
      
      if (room.otherMember) {
        if (room.otherMember.identity) {
          this.showUserProfileLink = true;
          this.otherMemberUid = room.otherMember.identity;
          this.getOtherMemberDetails(room.otherMember.identity)
        }
      }
      this.currentRoomIsArchived = room.archived;

      // Select Active/Archive chat tab
      // if(room.archived) this.activeBox = "archived"
      // else this.activeBox = "inbox"

      this.userHasRooms = true;
      this.roomRequestStatus = "active";

      // listingRequests components will detect the roomProspectAndOwnerUid var change in the watcher and reload requests.
      this.roomProspectAndOwnerUid = [
        room.attributes.prospectUid,
        room.attributes.ownerUid
      ];

      if (room.attributes.prospectUid == this.currentChatUserId)
        this.displayRequestForProspect = true;
      else if (room.attributes.ownerUid == this.currentChatUserId)
        this.displayRequestForProspect = false;

      this.retrieveInitialMessages(room);
    },
    async getOtherMemberDetails(userUid){
      this.otherMemberDetails = {placeholder: "No Contact Info"}
      this.loadingOtherMemberDetails = true
      const acc =  await getAccountPublicDetails(userUid)
      if(acc && (acc.contactPhone || acc.contactEmail)) this.otherMemberDetails = acc
      this.loadingOtherMemberDetails = false
    },
    retrieveInitialMessages(room) {
      if (!this.currentRoomMessages || this.currentRoomMessages.length == 0)
        this.$store.dispatch("retrieveMessages", { room: room });
    },
    setSessionLastSeenMessages(room) {
      let latestMsgArriveDate = this.$store.getters.latestMsgArrivedDatePerRoom[
        room.id
      ];
      if (latestMsgArriveDate && latestMsgArriveDate != "") {
        this.$store.commit("setLastSeenMsgDateForRoom", {
          roomId: room.id,
          lastSeenDate: latestMsgArriveDate
        });
        this.$store.commit("setLastSeenMsgDateForRoomSession", {
          roomId: room.id,
          lastSeenDate: latestMsgArriveDate
        });
      }
    },
    selectRoomAsCurrentGate(event, room) {
      if (this.selectedRoomId != room.id) {
        this.selectRoomAsCurrent(room);
      }
    },
    selectArchivedRoomAsCurrentGate(event, room) {
      this.userHasRooms = true;
      this.selectRoomAsCurrent(room);
    },
    archiveRoomGate(event, room) {
      this.$dialog.confirm("Continue to confirm archiving?").then(() => {
        this.archiveRoom(room);
      });
    },
    inboxRoomGate(event, room) {
      this.activeBox = "inbox"; // navigate to inbox
      this.inboxRoom(room);
    },
    inboxRoom(room) {
      room.archived = false;
      this.moveRoomToInbox(room);
      if (this.userRoomStatuses) this.userRoomStatuses[room.id].status = 1;
      if (this.$store.getters.currentRoom.id == room.id) {
        this.setCurrentRoomToDefault();
      }
    },
    archiveRoom(room) {
      room.archived = true;
      this.moveRoomToArchive(room);
      if (this.userRoomStatuses) this.userRoomStatuses[room.id].status = 0;
      if (this.$store.getters.currentRoom.id == room.id) {
        sessionStorage.removeItem("lastSelectedRoomId");
        this.setCurrentRoomToDefault();
      }
    },
    moveRoomToInbox(room) {
      this.$store.commit("removeArchivedRoom", room.id);
      this.$store.commit("addNewRoom", room);
    },
    moveRoomToArchive(room) {
      this.$store.commit("removeRoom", room.id);
      this.$store.commit("addNewArchivedRoom", room);
    },
    handleSendMessageButton() {
      if (this.txtInMsgInputField.trim() && this.selectedRoom) {
        let msg = this.createMessage({
          msgTxt: this.txtInMsgInputField,
          hidden: false,
          room: this.selectedRoom
        });
        this.txtInMsgInputField = "";
        this.sendMessage(msg);
      }
    },
    sendAttachment(attachment, attachmentName) {
      try {
        let attachmentMessage = this.createAttachmentMessage({
          attachment: attachment,
          attachmentName: attachmentName,
          hidden: false
        });
        this.chatMessagingService.sendAttachmentMessage(attachmentMessage);
      } catch (error) {
        console.error("sendMessage | catch > ex:", ex);
      }
    },
    saveRequestEdits({ request, whatChanged }) {
      // HIDDEN MESSAGE to facilitate real time inqury update
      this.sendHiddenMessage(JSON.stringify(request));

      // AUTO MESSAGE to facilitate negotiation trail
      var autoMessage = getInquiryChangeMessage({
        whoChanged: this.currentUserFirstName
      });
      this.sendAutoMessage(autoMessage);
    },
    sendInitialMessageIfNeeded() {
      if (this.initialChatMsg) this.sendAutoMessage(this.initialChatMsg);
      this.initialChatMsg = "";
    },
    sendAutoMessage(message) {
      var autoMessage = this.createMessage({
        msgTxt: message,
        auto: true,
        systemCode: systemMessageCodes.autoMessageCode
      });
      this.sendMessage(autoMessage);
    },
    sendHiddenMessage(message) {
      var hiddenMessage = this.createMessage({
        msgTxt: message,
        hidden: true,
        systemCode: systemMessageCodes.requestUpdateCode
      });
      this.sendMessage(hiddenMessage);
    },
    sendMessage(message) {
      try {
        this.$store.dispatch("sendMessage", { message });
        if (this.currentRoomIsArchived) {
          this.moveRoomToInbox(this.$store.getters.currentRoom);
          this.currentRoomIsArchived = false;
          this.activeBox = "inbox";
        }
      } catch (ex) {
        console.error("sendMessage | catch > ex:", ex);
      }
    },
    createMessage({ msgTxt, hidden, auto, systemCode, room }) {
      var cm = new ChatMessage({
        id: Math.floor(Math.random() * 100) + 100,
        textMessage: msgTxt.trim(),
        roomId: this.selectedRoomId,
        hidden: hidden,
        unsent: true,
        auto: auto,
        attributes: {
          systemCode: systemCode,
          memberUids: []
        },
        timestamp: new Date() // add current date as temp in order to avoid missing lastMessage timestamp in the ordering
      });

      if (room && room.attributes)
        cm.attributes.memberUids = room.attributes.memberUids;
      return cm;
    },
    createAttachmentMessage({ attachment, attachentName, hidden }) {
      return new AttachmentMessage({
        id: Math.floor(Math.random() * 100) + 100,
        roomId: this.selectedRoomId,
        hidden: hidden,
        unsent: true,
        loading: true,
        msgType: "media",
        attachment: attachment,
        attachentName: attachentName
      });
    },
    getMessageStatusIconClass(message) {
      if (message.isOther) {
        return "msg-sent-status-icon hidden";
      } else if (message.unsent && message.loading) {
        return "msg-sent-status-icon loading";
      } else if (message.unsent) {
        return "msg-sent-status-icon unsent";
      } else {
        return "msg-sent-status-icon sent";
      }
    },
    setRoomMessageClass(message) {
      var classNames = "room-message";

      if (message.hidden) classNames += " hiddenMessage";
      else if (message.auto) classNames += " autoMessage";
      else if (message.isOther) classNames += " otherMessage";
      else classNames += " myMessage";

      return classNames;
    },
    async fetchOlderMessages() {
      try {
          this.loadingOlderMsgs = true;
          let roomId = this.$store.getters.currentRoom.id;

          if (!Object.keys(this.$store.getters.roomMessages).length || !this.selectedRoom || !this.selectedRoom.id) {
              this.disableLoadOlderMsgs = true;
              return;
          }
          if (!this.$store.getters.roomMessages.hasOwnProperty(this.selectedRoom.id)) {
              this.disableLoadOlderMsgs = true;
              return;
          }
          const selectedRoomMessages = this.$store.getters.roomMessages[this.selectedRoom.id];
          if (!Array.isArray(selectedRoomMessages) || !selectedRoomMessages.length) {
              this.disableLoadOlderMsgs = true;
              return;
          }

          let oldestMessageIndex = this.$store.getters.roomMessages[
              this.selectedRoom.id
              ][0].index;
          if (oldestMessageIndex == this.prevOldestMsgId) {
              this.disableLoadOlderMsgs = true;
              this.loadingOlderMsgs = false;
              return;
          }

          var messages;
          if (this.selectedRoom && oldestMessageIndex > 0) {
              await this.$store.dispatch("retrieveMessages", {
                  room: this.selectedRoom,
                  filter: new FetchMessagesQuery(30, oldestMessageIndex - 1)
              });
          }
          if (messages && messages.length > 0) {
              this.prevOldestMsgId = oldestMessageIndex;
              this.disableLoadOlderMsgs = false;
          } else {
              this.disableLoadOlderMsgs = true;
          }
      }
      catch (error) {
          console.error(error);
      }
      finally {
          this.loadingOlderMsgs = false;
      }
    },
    scrollToEndOfMessages() {
      var container = this.$el.querySelector("#msg-log");
      if (container) container.scrollTop = container.scrollHeight;
    },
    isRoomCurrent(room) {
      return this.$store.getters.currentRoom.id == room.id;
    },
    showRoomName(room) {
      return room.name != "unk";
    },
    navigateTo({ where, params }) {
      this.$router.push({
        name: where,
        params: params
      });
    },
    updateRoomInIfNeeded(roomId, newName) {
      let room = this.getLocalRoomById(roomId);
      if (room.name != newName) {
        room.name = newName;
        this.chatMessagingService.updateRoom(
          new UpdateRoomCommand({
            roomId: roomId,
            roomName: newName,
            isPrivateRoom: true
          })
        );
      }
    }
  }
};
</script>
<style scoped>
@import "../assets/styles/chat.css";
@import "../assets/styles/global.css";

.hover-button {
  position: absolute;
}
.hover-button.top-right {
  right: 10px;
}
.hover-button.top-left {
  left: 10px;
}

.el-tabs__nav-wrap{
 padding-left: 1em; 
 height: 50px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/chat.vue